import Button from '../../common/Button/Button';
import styles from './ContactForm.module.scss';
import { useState } from 'react';
import emailjs from '@emailjs/browser';

const ContactForm = () => {
  // mailing
  const [status, setStatus] = useState('');

  const handleSubmit = (event) => {
    event.preventDefault();
    emailjs
      .sendForm(
        'service_o7j9ab6',
        'template_qdd5zsx',
        event.target,
        'Dntv-zBJlF5vzBLco'
      )
      .then(
        (response) => {
          // console.log('SUCCESS!', response);
          setStatus('Wiadomość została wysłana!');
          event.target.reset();
        },
        (error) => {
          // console.error('FAILED...', error);
          setStatus('Wystąpił błąd. Spróbuj ponownie później.');
        }
      );
  };

  return (
    <div className={styles.container}>
      <h2>Skontaktuj się z nami</h2>
      <form className={styles.form} onSubmit={handleSubmit}>
        <label>Imię i nazwisko *</label>
        <input type='text' name='name' placeholder='Jan Kowalski' required />
        <label>E-mail *</label>
        <input type='email' name='email' placeholder='Adres e-mail' required />
        {/* <label>Telefon kontaktowy</label>
        <input type='text' name='name' placeholder='500 000 000' /> */}
        <label>Wiadomość *</label>
        <textarea name='message' placeholder='Wiadomość' required></textarea>
        <div className={styles.info}>
          <p>Pola obowiązkowe *</p>
          <Button> Wyślij wiadomość </Button>
        </div>
      </form>
      {status && <p>{status}</p>}
    </div>
  );
};

export default ContactForm;
